{
  "_hinweis": "Die acht Kisten – Stationen im Leben einer Anlage (ANFORDERUNGEN.md 14.1; Mockup). stufe: s1 = in Stufe 1 gebaut, teil = in Stufe 1 ein Teil davon, spaeter = als Platzhalter sichtbar (CLAUDE.md, Grundsatz 8). Seit E3c (H26) die Bestellung an Stelle des Lagers – ein großes Lager gibt es nicht mehr.",
  "kisten": [
    { "schluessel": "lead", "name": "Lead", "wer": "Lead-Management (Happy Energy)", "stufe": "spaeter" },
    { "schluessel": "doku", "name": "Sales / Doku", "wer": "Verkauf, beim Kunden", "stufe": "s1" },
    { "schluessel": "termin", "name": "Termin", "wer": "Verkauf, noch beim Kunden", "stufe": "teil" },
    { "schluessel": "dachplanung", "name": "Dachplanung", "wer": "K2 – draußen beim Verkauf", "stufe": "teil" },
    { "schluessel": "bestellung", "name": "Bestellung", "wer": "Büro – beim Lieferanten", "stufe": "teil" },
    { "schluessel": "montage", "name": "Montage", "wer": "Montage-Partie", "stufe": "teil" },
    { "schluessel": "inbetriebnahme", "name": "Inbetriebnahme", "wer": "Inbetriebnahme-Technik", "stufe": "spaeter" },
    { "schluessel": "nachsorge", "name": "Nachsorge", "wer": "automatisch, drei Tage später", "stufe": "spaeter" }
  ]
}
